/* ============================================================
   Journal MRB — kit article (seo-journal-kit)
   1. Temps de lecture dans la byline
   2. Sommaire ancré auto-généré depuis les H2 du body
   3. Hydratation des cartes produit (prix LIVE via /products/<handle>.js)
   Chargé (defer) par sections/main-article.liquid uniquement.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var container = document.querySelector('.article-container');
    if (!container) return;
    readingTime(container);
    buildToc(container);
    hydrateProductCards(container);
    faqAccordions(container);
    progressBar();
    stickyBuy();
  }

  /* --- Template journal : FAQ h3+contenu -> accordéons <details> --- */
  function faqAccordions(container) {
    if (!document.querySelector('[data-cjy-body]')) return; // journal uniquement
    var h2s = container.querySelectorAll('h2');
    var faqH2 = null;
    h2s.forEach(function (h) { if (/^faq/i.test(h.textContent.trim())) faqH2 = h; });
    if (!faqH2) return;
    var node = faqH2.nextElementSibling;
    while (node && node.tagName === 'H3') {
      var d = document.createElement('details');
      d.className = 'seo-faq';
      var s = document.createElement('summary');
      s.textContent = node.textContent;
      d.appendChild(s);
      var content = node.nextElementSibling;
      var next;
      while (content && !/^H[23]$/.test(content.tagName) && !content.classList.contains('cjy-auteur')) {
        next = content.nextElementSibling;
        d.appendChild(content);
        content = next;
      }
      node.replaceWith(d);
      node = d.nextElementSibling;
    }
    var first = container.querySelector('details.seo-faq');
    if (first) first.open = true;
  }

  /* --- Template journal : barre de progression de lecture --- */
  function progressBar() {
    var bar = document.querySelector('[data-cjy-progress]');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var h = document.documentElement;
      bar.style.width = (h.scrollTop / (h.scrollHeight - h.clientHeight) * 100) + '%';
    }, { passive: true });
  }

  /* --- Template journal : barre d'achat sticky mobile --- */
  function stickyBuy() {
    var sb = document.querySelector('[data-cjy-stickybuy]');
    if (!sb) return;
    // Une barre qu'on ne peut pas fermer est une barre qu'on subit. Le refus
    // vaut pour la session : la rouvrir a chaque article serait le meme defaut.
    var CLE = 'cjy-stickybuy-ferme';
    var ferme = false;
    try { ferme = sessionStorage.getItem(CLE) === '1'; } catch (e) {}
    var croix = sb.querySelector('[data-cjy-sbclose]');
    if (croix) {
      croix.addEventListener('click', function () {
        ferme = true;
        sb.classList.remove('cjy-visible');
        try { sessionStorage.setItem(CLE, '1'); } catch (e) {}
      });
    }
    window.addEventListener('scroll', function () {
      if (ferme) return;
      var h = document.documentElement;
      var pct = h.scrollTop / (h.scrollHeight - h.clientHeight) * 100;
      sb.classList.toggle('cjy-visible', window.innerWidth < 900 && pct > 15 && pct < 88);
    }, { passive: true });
  }

  /* --- 1. Temps de lecture --- */
  function readingTime(container) {
    var slot = document.querySelector('.seo-reading-time');
    if (!slot) return;
    var words = (container.innerText || '').trim().split(/\s+/).length;
    var minutes = Math.max(1, Math.round(words / 220));
    slot.textContent = minutes + ' min de lecture';
    slot.hidden = false;
  }

  /* --- 2. Sommaire ancré : dans le rail (template journal) sinon inline --- */
  function buildToc(container) {
    var h2s = container.querySelectorAll('h2');
    var rail = document.querySelector('[data-cjy-toc]');
    if (h2s.length < (rail ? 3 : 4)) return;
    h2s.forEach(function (h2, i) {
      if (!h2.id) {
        h2.id = 'section-' + (i + 1) + '-' + h2.textContent.toLowerCase()
          .normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 60);
      }
    });
    if (rail) {
      var links = [];
      h2s.forEach(function (h2) {
        var a = document.createElement('a');
        a.href = '#' + h2.id;
        a.textContent = h2.textContent;
        rail.appendChild(a);
        links.push({ a: a, h2: h2 });
      });
      rail.hidden = false;
      window.addEventListener('scroll', function () {
        var cur = 0;
        links.forEach(function (l, i) {
          if (l.h2.getBoundingClientRect().top < 130) cur = i;
        });
        links.forEach(function (l, i) { l.a.classList.toggle('on', i === cur); });
      }, { passive: true });
      return;
    }
    var toc = document.createElement('nav');
    toc.className = 'seo-toc';
    var title = document.createElement('div');
    title.className = 'seo-toc__title';
    title.textContent = 'Sommaire';
    toc.appendChild(title);
    var ol = document.createElement('ol');
    h2s.forEach(function (h2) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h2.id;
      a.textContent = h2.textContent;
      li.appendChild(a);
      ol.appendChild(li);
    });
    toc.appendChild(ol);
    container.insertBefore(toc, container.firstChild.nextSibling || container.firstChild);
  }

  /* --- 3. Cartes produit : prix et image en direct, jamais codés en dur --- */
  function hydrateProductCards(container) {
    var cards = container.querySelectorAll('.seo-product-card[data-handle]');
    cards.forEach(function (card) {
      var handle = card.getAttribute('data-handle');
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) { renderCard(card, p); })
        .catch(function () { card.style.display = 'none'; });
    });
  }

  function euro(centimes) {
    return (centimes / 100).toFixed(2).replace('.', ',') + '€';
  }

  function renderCard(card, p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var variant = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { variant = p.variants[i]; break; }
    }
    var label = card.getAttribute('data-label') || p.title;
    // Prix ET prix barre viennent de la MEME variante, celle qu'on affiche.
    // Au niveau du produit, « price » est le prix MINIMUM (la variante x1) alors
    // que « compare_at_price » peut venir d'une AUTRE variante (le lot x2) : on
    // annoncait alors « 22,98€ barre / 11,49€ », soit une remise de 50 % qui
    // n'existe pas. Constate le 2026-08-25 sur cinq produits vendus en lot.
    var vAff = variant || p.variants[0];
    var prix = euro(vAff.price);
    var prixBarre = '';
    if (vAff.compare_at_price && vAff.compare_at_price > vAff.price) {
      prixBarre = '<s class="seo-product-card__compare">' + euro(vAff.compare_at_price) + '</s> ';
    }
    var html = '';
    if (img) {
      html += '<a href="' + p.url + '"><img class="seo-product-card__img" loading="lazy" src="' +
        img + '" alt="' + escapeHtml(label) + '"></a>';
    }
    html += '<div class="seo-product-card__body">' +
      '<p class="seo-product-card__title"><a href="' + p.url + '">' + escapeHtml(label) + '</a></p>' +
      '<div class="seo-product-card__price"><a href="' + p.url + '">' + prixBarre + prix + '</a></div>';
    // Trafic froid : on n'ajoute pas au panier depuis un article, on envoie
    // sur la fiche, qui a les avis, les variantes et l'argumentaire.
    html += '<a class="seo-product-card__btn" href="' + p.url + '">Découvrir</a>';
    html += '</div>';
    card.innerHTML = html;
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
